import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {SmallPerkboxLogo} from "@irati/ui/src/Logos"

import Flex from "../../Flex"
import {H6} from "../../Typography"
import Button from "../../Button/Button"

import {Container} from "./styled"

interface Props {}

const AppStoreBanner: FC<Props> = () => {
  const handleOnClick = () => {
    const utmSource = "banner"
    const utmMedium = "link"
    const currentUrl = window.location.href.split("?")[0]
    window.location.assign(`${currentUrl}?redirectToAppStore=true&utm_source=${utmSource}&utm_medium=${utmMedium}`)
  }
  return (
    <Container justifyContent="space-between" direction="row">
      <Flex justifyContent="center" alignItems="center">
        <SmallPerkboxLogo size={42} />
        <H6 marginLeft={1.5}>
          <FormattedMessage id="platform.appBanner.title" />
        </H6>
      </Flex>
      <Button small primary onClick={handleOnClick}>
        <FormattedMessage id="platform.appBanner.btn" />
      </Button>
    </Container>
  )
}

export default AppStoreBanner
